import React, { useState, useEffect } from 'react';
import {
	Box,
	HStack,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Text,

} from '@chakra-ui/react'
import { Link } from "react-router-dom";
import CustomModal from '../../components/CustomModal'
import CustomModalLink from '../../components/CustomModalLink'
import PageLoader from '../../components/Loader/PageLoader';
import Create from './Create';
import Edit from './Edit';

import { fetchWrapper } from '../../helpers';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';

function List() {

	const { isOpen, onOpen, onClose } = useDisclosure();
	const { onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
	const [isOpenEdit, setIsOpenEdit] = useState(false)
	const [modalEditView, setModalEditView] = useState(false)
	const [list, setList] = useState([])
	const [loading, setLoading] = useState(false);
	const meClose = () => {

		onClose();
	}

	useEffect(() => {
		loadList();
	}, [])

	const loadList = async () => {
		setLoading(true)
		const url = `${process.env.REACT_APP_API_URL}/price_channel/list`;
		const data = await fetchWrapper.get(url)
		setList(data.data);
		setLoading(false)
	}

	const meEdit = (rs) => {
		setIsOpenEdit(true);
		setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
	}

	const meCloseEdit = () => {

		setIsOpenEdit(false);

	}



	return (
		<>

			<PageLoader isLoading={loading} />
			<CustomModalLink
				showModalButtonText="Status Edit"
				modalHeader="Status Edit"
				isOpenEdit={isOpenEdit}
				onCloseEdit={meCloseEdit}
				onOpenEdit={onOpenEdit}

				modalBody={modalEditView}
			/>
			
				<div >

					<HStack justifyContent="space-between">
						<Box>
							<Text fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Open Sans', sans-serif">Price List</Text>
						</Box>
						<Box>
							<HStack>

								<Box>
									<CustomModal
										showModalButtonText="Add New Price List"
										modalHeader="Add Price List"
										isOpen={isOpen}
										onClose={onClose}
										onOpen={onOpen}
										modalBody={<Create meClose={meClose} loadList={loadList} />}
									/>
								</Box>
							</HStack>
						</Box>
					</HStack>



					<div className="table_section">
						<TableContainer width="100%">
							<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
								<Thead >
									<Tr>
										<Th>Name</Th>
										<Th></Th>

									</Tr>
								</Thead>
								{list.length > 0 ? <Tbody fontSize="14px">
									{list.map((rs, index) => {
										return (

											<Tr key={rs?.id || index}>
												<Td>{rs.name}</Td>


												<Td >
													<Link
														to={`/sms-price/${rs.id}`}
														state={{ id: rs.id }}
													>
														View Price List
													</Link>
												</Td>

											</Tr>

										)
									})}
								</Tbody> : <Text>No data found</Text>}
							</Table>
						</TableContainer>
					</div>

				</div>
			
		</>
	)
}


export default List
